// src/components/SummarizerModal.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';  // Импорт

function SummarizerModal({ isOpen, onClose, onAnalyze, summary }) {
  const navigate = useNavigate();  // <-- Теперь здесь, в теле компонента

  const [loading, setLoading] = useState(false);

  const handleAnalyze = async () => {
    setLoading(true);
    try {
      await onAnalyze();
    } catch (error) {
      console.error('Ошибка анализа:', error);
    } finally {
      setLoading(false);
    }
  };

  const navigateToMeasure = (categoryCode, measureId) => {
    const viewMap = {
      socvyplaty: '/payouts',
      health: '/health',
      tsr: '/tsr',
      work: '/work',
      law: '/law',
      education: '/edu',      // Правильный ключ
      sport: '/sport',
      culture: '/culture',
    };
    const path = viewMap[categoryCode] || '/payouts';
    navigate(measureId ? `${path}/${measureId}` : path);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div className="modal-content shadow-lg border-0">
          {/* Заголовок модалки */}
          <div className="modal-header border-0 pb-2">
            <h4 className="modal-title fw-bold text-primary mb-0">
              Что ещё вы можете получить?
            </h4>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Закрыть"
            />
          </div>

          {/* Основное содержимое */}
          <div className="modal-body pt-0">
            <div id="summarizerResult">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Загрузка...</span>
                  </div>
                  <p className="mt-3 text-muted">Анализируем отмеченные документы...</p>
                </div>
              ) : summary ? (
                summary.potential_measures?.length > 0 ? (
                  <div className="accordion accordion-flush">
                    {summary.potential_measures.map((op, index) => (
                      <div className="accordion-item" key={index}>
                        <h2 className="accordion-header" id={`heading${index}`}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${index}`}
                            aria-expanded="false"
                            aria-controls={`collapse${index}`}
                          >
                            {op.title}
                            {op.missing_count === 0 ? (
                              <span className="badge bg-success ms-2">Все документы есть!</span>
                            ) : (
                              <span className="badge bg-warning text-dark ms-2">
                                Не хватает: {op.missing_count}
                              </span>
                            )}
                          </button>
                        </h2>
                        <div
                          id={`collapse${index}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading${index}`}
                        >
                          <div className="accordion-body">
                            {op.missing_count > 0 && op.missing_docs?.length > 0 && (
                              <p className="text-muted mb-3">
                                Нужно дособрать: {op.missing_docs.join(', ')}
                              </p>
                            )}
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => navigateToMeasure(op.category_code, op.id)}
                            >
                              Перейти к мере →
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-center text-muted py-4">
                    Пока нет мер, к которым вы близки. Отмечайте документы в чеклистах!
                  </p>
                )
              ) : (
                <p className="text-center text-muted py-4">
                  Отметьте галочками документы, которые у вас уже есть, и нажмите кнопку ниже.
                </p>
              )}
            </div>
          </div>

          {/* Кнопка анализа внизу */}
          <div className="modal-footer border-0 justify-content-center pt-3">
            <button
              className="btn btn-success btn-lg px-5"
              onClick={handleAnalyze}
              disabled={loading}
            >
              {loading ? 'Анализ...' : 'Показать доступные меры'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummarizerModal;